export enum SimpleFilterEnum {
  Signaling = 'Sinalizações',
  Task = 'Tarefas',
  WaitTask = 'Tarefas em Aguardo',
  CompletedTask = 'Tarefas Concluídas',
}

export enum ActiveLayersEnum {
  Retroreflection = 'Alertas de Retrorrefletorização',
  PathMarker = 'Marcadores Quilométricos',
  Paths = 'Trajetos',
  Routes = 'Rotas',
  Region = 'Regiões',
  Area = 'Áreas',
}
